import { Box, Container, Stack, Typography, IconButton, useTheme, alpha, Tooltip, useMediaQuery } from '@mui/material'
import { Phone as PhoneIcon, Email as EmailIcon, WhatsApp as WhatsAppIcon } from '@mui/icons-material'
import { motion, AnimatePresence } from 'framer-motion'

const MotionBox = motion(Box)
const MotionStack = motion(Stack)
const MotionTypography = motion(Typography)

const TopBar = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))

  const ContactButton = ({ icon, label, href, tooltip, index }: { icon: React.ReactNode; label: string; href: string; tooltip: string; index: number }) => (
    <Tooltip title={tooltip} arrow>
      <MotionStack
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 0.5,
          delay: 0.2 + (index * 0.1),
          ease: "easeOut"
        }}
        whileHover={{ 
          y: -2,
          scale: 1.05,
          transition: { duration: 0.2 }
        }}
        whileTap={{ scale: 0.95 }}
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{
          color: 'common.white',
          textDecoration: 'none',
          '& .MuiSvgIcon-root': {
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
            color: 'inherit',
          },
          px: { xs: 0.5, sm: 1 },
        }}
        onClick={() => window.open(href, '_blank')}
        style={{ cursor: 'pointer' }}
      >
        <Box
          component={motion.div}
          whileHover={{ rotate: [0, -10, 10, -10, 0] }}
          transition={{ duration: 0.4 }}
        >
          {icon}
        </Box>
        <MotionTypography
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ 
            duration: 0.3,
            delay: 0.3 + (index * 0.1)
          }}
          variant="body2" 
          sx={{ 
            display: { xs: 'none', sm: 'block' },
            fontWeight: 500,
            color: 'common.white',
            fontSize: { sm: '0.8rem', md: '0.875rem' },
          }}
        >
          {label}
        </MotionTypography>
      </MotionStack>
    </Tooltip>
  )

  return (
    <MotionBox
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ 
        type: "spring",
        stiffness: 100,
        damping: 20,
        duration: 0.8
      }}
      sx={{
        background: `linear-gradient(to right, ${theme.palette.grey[900]}, ${alpha(theme.palette.primary.dark, 0.95)})`,
        borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
        py: { xs: 1, sm: 1.25, md: 1.5 },
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.appBar + 1,
        boxShadow: `0 1px 8px ${alpha(theme.palette.common.black, 0.15)}`,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '2px',
          background: `linear-gradient(90deg, 
            ${alpha(theme.palette.primary.main, 0)}, 
            ${alpha(theme.palette.primary.main, 0.5)}, 
            ${alpha(theme.palette.primary.main, 0)}
          )`,
        }
      }}
    >
      <Container maxWidth="xl">
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={{ xs: 2, sm: 3, md: 4 }}
        >
          <ContactButton
            icon={<PhoneIcon fontSize={isMobile ? "small" : "medium"} />}
            label="+91 7978190633"
            href="tel:+917978190633"
            tooltip="Call us"
            index={0}
          />
          <ContactButton
            icon={<WhatsAppIcon fontSize={isMobile ? "small" : "medium"} />}
            label="+91 7978190633"
            href="https://wa.me/917978190633"
            tooltip="Chat on WhatsApp"
            index={1}
          />
          {!isMobile && (
            <ContactButton
              icon={<EmailIcon fontSize={isMobile ? "small" : "medium"} />}
              label="hotelbisworupainn@gmail.com"
              href="mailto:hotelbisworupainn@gmail.com"
              tooltip="Email us"
              index={2}
            />
          )}
        </Stack>
      </Container>
    </MotionBox>
  )
}

export default TopBar 